<template>
  <div class="body-container">
    <participant-login-disclaimer v-show="flags.joinIntro" :isDisclaimerVisible="flags.joinIntro" :languageCulture="lang" :widget="widget" />
    <div class="signIn-container signIn-container-xs-screen border-container d-flex align-items-center justify-content-center">
      <LanguageCountries v-if="flags.start" :lang="lang" :languageId="portal.getLanguage()" :countryId="portal.getCountry()" :studyId="portal.getStudy()" @updateHeaderNav="updateHeaderNav" :eventType="'joinStudy'" @updateActiveScreen="updateActiveScreen"></LanguageCountries>
      <JoinIntro v-if="flags.joinIntro" :lang="lang" :isJoinButtonDisabled="isJoinButtonDisabled" :isLoginButtonEnable="isLoginButtonEnable" @updateHeaderNav="updateHeaderNav" @updateActiveScreen="updateActiveScreen"></JoinIntro>
      <ActivationCode v-if="flags.isReadyToJoinStudy && !portal.isOpenEnrollmentStudy()" :lang="lang" @updateHeaderNav="updateHeaderNav" @updateActiveScreen="updateActiveScreen" :isOnBackClick="isOnBackClick" :showCodeInput="showCodeInput"></ActivationCode>
      <EligibilityQuestions v-else-if="flags.isReadyToJoinStudy" :lang="lang" @updateHeaderNav="updateHeaderNav" @updateActiveScreen="updateActiveScreen" @onEligibilityCheck="saveEligibility" :isOnBackClick="isOnBackClick" :showCodeInput="showCodeInput"></EligibilityQuestions>
      <Eula v-if="flags.isActivationCodeVerified" :lang="lang" @updateHeaderNav="updateHeaderNav" @updateActiveScreen="updateActiveScreen" :isOnBackClick="isOnBackClick" @backButtonClicked="eulaBackButtonClick" :listOfCohorts="listOfCohorts" @onChangeCohorts="val => (listOfCohorts = val)" :eligibilityQuestionsAns="eligibilityQuestionsAns"></Eula>
      <CohortList :lang="lang" v-if="flags.isCohortCompleted" :listOfCohorts="listOfCohorts" @updateHeaderNav="updateHeaderNav" @updateActiveScreen="updateActiveScreen" @onCohortClick="onCohortSelect" :isOnBackClick="isOnBackClick" />
      <Consent
        v-if="flags.isDetailsCorrect"
        :lang="lang"
        :consentIndex="consentIndex"
        :active="flags.isDetailsCorrect"
        :consentScreen="consentScreen"
        @consentChanged="val => (consentIndex = val)"
        @updatedConsentScreen="val => (consentScreen = val)"
        @updateHeaderNav="updateHeaderNav"
        @updateActiveScreen="updateActiveScreen"
        :isOnBackClick="isOnBackClick"
        :selectedCohort="selectedCohort"
        :consentSignatureAndDisclaimer="consentSignatureAndDisclaimer"
        :listOfCohorts="listOfCohorts"
        :isDatavantTokenizationEnabled="isDatavantTokenizationEnabled"
      ></Consent>
      <Registration v-if="flags.isConcentSignCompleted" :lang="lang" @updateHeaderNav="updateHeaderNav" @updateActiveScreen="updateActiveScreen" :isOnBackClick="isOnBackClick" :selectedCohort="selectedCohort" :consentSignatureAndDisclaimer="consentSignatureAndDisclaimer" :isDatavantTokenizationEnabled="isDatavantTokenizationEnabled" />
      <Modal :show="showCancelModal" :title="widget.translate('ml_are_you_sure', 'Are you sure?')" helpText="" :cancelButton="widget.translate('CANCEL_BUTTON_TITLE', 'Cancel')" :okButton="widget.translate('rsb_discard_results', 'Discard Results')" @modalCallback="modalOkCallback"></Modal>
    </div>
  </div>
</template>

<script>
import JoinIntro from "@/components/participant-portal/auth/join/intro";
import LanguageCountries from "@/components/participant-portal/auth/language-countries";
import ActivationCode from "@/components/participant-portal/auth/join/activation-code";
import Eula from "@/components/participant-portal/auth/join/eula";
import Consent from "@/components/participant-portal/auth/join/consent";
import EligibilityQuestions from "@/components/participant-portal/auth/join/eligibility-questions";
import Registration from "./registration";
import Modal from "@/components/participant-portal/common/modal";
import nprogress from "nprogress";
import { mapGetters } from "vuex";
import { Widget, ParticipantPortal } from "@/components/services/participant-service";
import CohortList from "./cohort-list.vue";
import ParticipantLoginDisclaimer from "../../common/participant-login-disclaimer.vue";

export default {
  name: "join",
  components: {
    JoinIntro,
    ActivationCode,
    Eula,
    Consent,
    Registration,
    Modal,
    CohortList,
    LanguageCountries,
    EligibilityQuestions,
    ParticipantLoginDisclaimer
  },
  props: ["isOnCancelClick", "isOnBackClick", "isJoinButtonDisabled"],
  data() {
    return {
      widget: new Widget(),
      portal: new ParticipantPortal(),
      showCancelModal: false,
      showCodeInput: false,
      consentScreen: "education",
      consentIndex: 0,
      flags: {
        start: false,
        languageOptions: false,
        isDetailsCorrect: false,
        isReadyToJoinStudy: false,
        isActivationCodeVerified: false,
        isConcentEducationCompleted: false,
        isConcentQuestionsCompleted: false,
        isConcentDisclaimerCompleted: false,
        isConcentSignCompleted: false,
        isCohortCompleted: false
      },
      selectedCohort: null,
      consentSignatureAndDisclaimer: [],
      screenAfterCancelClosed: null,
      listOfCohorts: null,
      eligibilityQuestionsAns: null,
      isDatavantTokenizationEnabled: false
    };
  },
  mounted() {
    this.$emit("setHeaderOptions", null);
    this.getBitriseData();
    this.$root.$on("SetAfterCancelClosedScreen", screen => {
      if (typeof screen === "string") {
        this.screenAfterCancelClosed = screen;
      }
      this.$root.$emit("JoinActiveScreenChanged");
    });
    this.$root.$on("resetToCohort", () => {
      this.modalOkCallback();
    });
    this.checkIfDatavantTokenizationEnabled();
  },
  computed: {
    ...mapGetters(["participant", "participantRegistration"]),
    globalElements() {
      return this.$store.getters.getParticipantsPortalGlobalElements;
    },
    isLoginButtonEnable() {
      const isParticipantFromWeb = this.portal.isFromWeb();
      const version = this.portal.getVersion();
      if (isParticipantFromWeb == "true") {
        return false;
      }
      return !!(typeof version === "string" && version.includes("-"));
    },
    lang() {
      const selectedLanguage = this.$store.getters.getParticipantsPortalLanguages;
      return selectedLanguage ? selectedLanguage.language_culture : "en";
    }
  },
  watch: {
    isOnCancelClick() {
      this.showCancelModal = !this.showCancelModal;
    }
  },
  methods: {
    saveEligibility(questions) {
      this.eligibilityQuestionsAns = questions;
    },
    eulaBackButtonClick() {
      this.updateActiveScreen("isReadyToJoinStudy");
      this.showCodeInput = true;
    },
    setParticipantRegistration() {
      this.participantRegistration.studyId = this.globalElements && this.globalElements.studyId;
    },
    onCohortSelect(cohort) {
      this.selectedCohort = cohort;
      this.updateActiveScreen("isDetailsCorrect");
    },
    modalOkCallback() {
      this.$router.push({ name: "participants-portal-auth-join" });
      this.updateActiveScreen(this.screenAfterCancelClosed == null ? "joinIntro" : this.screenAfterCancelClosed);
      this.screenAfterCancelClosed = null;
      this.consentScreen = "education";
      this.consentIndex = 0;
      this.consentSignatureAndDisclaimer = [];
      this.participantRegistration.participantMeta.firstName = "";
      this.participantRegistration.participantMeta.lastName = "";
    },
    updateActiveScreen(keyOld) {
      let key = keyOld;
      this.showCodeInput = false;
      if (key === "isCohortCompleted" && this.listOfCohorts && this.listOfCohorts.length === 1) {
        key = "isDetailsCorrect";
      }
      if (typeof key === "object") {
        this[key.flagKey] = key.flagValue;
        key = key.key;
      }
      for (const [k] of Object.entries(this.flags)) {
        this.flags[k] = false;
      }

      if (key == "joinIntro") {
        this.$emit("setHeaderOptions", { showBlankHeader: false, title: "" });
      } else if (key == "start") {
        this.$emit("setHeaderOptions", null);
      }

      this.flags[key] = true;
      this.screenAfterCancelClosed = null;
    },
    updateHeaderNav(options) {
      this.$emit("setHeaderOptions", options);
    },
    getBitriseData() {
      nprogress.start();
      const that = this;
      this.portal
        .getBitriseData()
        .then(
          () => {
            that.portal
              .getGlobalElementsObject()
              .then(
                () => {
                  that.setParticipantRegistration();
                  this.widget.getActivityTranslation(this.study, this.lang).then(() => {});
                  that.flags.start = true;
                  nprogress.done();
                },
                () => {
                  nprogress.done();
                }
              )
              .catch(() => {
                nprogress.done();
              });
          },
          () => {
            nprogress.done();
          }
        )
        .catch(() => {
          nprogress.done();
        });
    },
    checkIfDatavantTokenizationEnabled() {
        if(!this.portal.getStudy()){
            return;
        }

        this.$api.getDatavantWebToggleState({ studyId: this.portal.getStudy(), featureKey : "DatavantTokenization" })
            .then(res => {
                this.isDatavantTokenizationEnabled = res.body && res.body[0] && res.body[0].enabled ? true : false;
            })
            .catch(err => {
                let message = this.widget.translate(
                    err.message,
                    "Error while fetching the study features details!"
                );
                if (message) {
                    this.$toastr.error(message);
                }
            });
    }
  }
};
</script>
<style lang="scss" scoped>
// For mobile screens
@media only screen and (max-width: 600px) {
  .signIn-container-xs-screen {
    min-height: 0px !important;
  }
}
</style>
